import { HammerUIProvider } from '@liveauctioneers/hammer-ui-core/providers';
import { ReactNode } from 'react';

import { mergedCaterwaulAndHammerUIThemes } from '@/theme/mergedCaterwaulAndHammerUIThemes';
import { useAmplitudeExperiments } from '@/utils/amplitude/experiments/utils/useAmplitudeExperiments';
import { variantsToFeatureFlags } from '@/utils/amplitude/experiments/utils/variantsToFeatureFlags';

type Props = {
    children: ReactNode;
};

export const AmplitudeFeatureFlagBridge = ({ children }: Props) => {
    const { variants } = useAmplitudeExperiments();
    const featureFlags = variantsToFeatureFlags(variants);

    return (
        <HammerUIProvider
            featureFlags={featureFlags}
            theme={mergedCaterwaulAndHammerUIThemes}
        >
            {children}
        </HammerUIProvider>
    );
};
